import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installBackTrap } from "./pwa/backTrap";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Wait a microtask so React Router's BrowserRouter has read the initial
// location before we seed our sentinel on top of it.  No-op outside a
// standalone PWA.
queueMicrotask(installBackTrap);

// Register the service worker.  Only in production builds — under `vite dev`
// the dev server serves modules with HMR that the SW would intercept and
// break.  On localhost / file:// (no service-worker support) this is a no-op.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[sw] registration failed:", err));
  });

  // When a brand-new SW takes control (sw.js's skipWaiting + clients.claim
  // from the install/activate handlers), the existing page is still
  // controlled by the OLD SW until something forces a switch.  Reloading
  // here picks up both the new SW AND ensures the page reruns under it —
  // which matters for /version.json polls (the old SW caches it without
  // the bypass; the new one bypasses).  Guarded against reload-loops via
  // a sessionStorage flag in case anything else triggers controllerchange
  // unexpectedly during a single page lifetime.
  let reloadingForSw = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForSw) return;
    reloadingForSw = true;
    window.location.reload();
  });
}
